import NewsroomMediaTwoContainer from "./container/NewsroomMediaTwoContainer";
export default NewsroomMediaTwoContainer;
